import clone from 'clone'
import { InsightsReportContract } from '../../reporting_v2/helpers/build-api-report-contract'
import { normalizeExportFilename } from '../../reporting_v2/helpers/normalize-export-filename'
import { JourneyPerformanceReport } from './revision-insights'

const VIEW_FILENAME_SLUG: Record<JourneyPerformanceReport, string> = {
    NOTIFICATIONS: 'notifications',
    STEPS: 'steps',
    SPLIT_TEST_VARIANTS: 'split_test_variants',
}

// Fields to drop from a user-facing export. IMPORTANT: only fields that are NOT used as
// filters may be pruned. The reporting backend validates every filter against the requested
// `fields` (a filter on `campaign.id` / `revision_id` is only accepted when that field is
// requested), and the notification breakdown does not implicitly add `campaign.id`. So the
// journey scope (`campaign.id`) and revision scope (`revision_id`) must remain in `fields`.
// `notification.source` is an internal, never-filtered column — matching the Insights
// section's own CSV export exclusion.
const EXPORT_EXCLUDED_FIELDS = ['notification.source']

export function buildJourneyExportContract(
    baseContract: InsightsReportContract,
    view: JourneyPerformanceReport,
    journey: { id: number | string },
    format: 'csv' | 'xlsx',
): InsightsReportContract {
    const contract: InsightsReportContract = clone(baseContract)

    contract.format = format
    contract.filename = normalizeExportFilename(`journey_${journey.id}_${VIEW_FILENAME_SLUG[view]}_report`)
    contract.fields = contract.fields.filter((field) => !EXPORT_EXCLUDED_FIELDS.includes(field))

    return contract
}

export type JourneyExportRequestScope = {
    requestScope: 'organizations' | 'domains'
    scopeId: number
}

export function resolveJourneyExportRequestScope(
    props: { level: 'org'; orgId: number } | { level: 'domain'; domainId: number },
): JourneyExportRequestScope {
    return {
        requestScope: props.level === 'org' ? 'organizations' : 'domains',
        scopeId: props.level === 'org' ? props.orgId : props.domainId,
    }
}
